import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/** Mirrors BUG_REPORT_LIMITS.descriptionMin/Max in services/shared/bug-reports.ts. */
export const BUG_REPORT_DESCRIPTION_MIN = 10;
export const BUG_REPORT_DESCRIPTION_MAX = 5000;

export interface BugReportSubmission {
  description: string;
  /** Route the user was on when they opened the dialog. */
  pageUrl: string;
  userAgent: string;
  /** e.g. "1440x900" */
  viewport: string;
}

export interface BugReportReceipt {
  id: string;
  status: string;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class BugReportService {
  private readonly base = `${environment.apiUrl}/api/v1`;

  constructor(private readonly http: HttpClient) {}

  submit(report: BugReportSubmission): Observable<BugReportReceipt> {
    return this.http.post<BugReportReceipt>(`${this.base}/bug-reports`, report);
  }
}
